(function () {
    function getCookie(cname) {
        const name = cname + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];

            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }

            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }

        return '';
    }

    window.haloNewsletterGate = {
        enabled: false,
        _pendingCallback: null,

        isPassed() {
            if (!this.enabled) {
                return true;
            }

            if (window.newsletterGate?.customerLoggedIn) {
                return true;
            }

            return getCookie('emailSubcribeModal') === 'closed';
        },

        run(callback) {
            if (!callback || typeof callback !== 'function') {
                return;
            }

            if (!this.enabled || this.isPassed()) {
                callback();
                return;
            }

            const popup = document.getElementById('halo-newsletter-popup');

            if (!popup) {
                callback();
                return;
            }

            this._pendingCallback = callback;
            document.body.classList.add('newsletter-show', 'newsletter-add-to-cart-gate');

            if (popup.classList.contains('customPopup-banner')) {
                window.setTimeout(() => {
                    document.body.classList.add('show-newsletter-image');
                }, 50);
            } else {
                document.body.classList.add('show-newsletter-image');
            }
        },

        complete() {
            const callback = this._pendingCallback;

            this._pendingCallback = null;
            document.body.classList.remove('newsletter-add-to-cart-gate');

            if (callback) {
                callback();
            }
        },

        cancel() {
            this._pendingCallback = null;
            document.body.classList.remove('newsletter-add-to-cart-gate');
        }
    };

    if (window.newsletterGate?.enabled) {
        window.haloNewsletterGate.enabled = true;
    }
})();
